<template>
<div id="not-found-container" class="modal">
  <div>
    <div class="modal-title">{{$t('NOPHONE.TITLE')}}</div>
    <div class="modal-content">
      <div class="header">
        <div class="title">404</div>
        <div class="close" @click="close"></div>
      </div>
      <div class="container row">
        404
      </div>
       <div class="action">
        <button class="btn" @click="close">{{$t('COMMON.CLOSE')}}</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'NotFoundContainer',
  methods: {
    close() {
      this.$router.push('/panel');
    },
  },
};
</script>

<style scoped lang="scss">
  #not-found-container {
  }
</style>



// WEBPACK FOOTER //
// src/views/NotFoundContainer.vue